module.exports = __webpack_public_path__ + "img/stop.eef38968.svg";